/* Name: SignInButton.jsx
* Copyright: (c) DA-Design Oy
* Creation date: 14.05.2024   (EKn)
*
* Description:
*/

import React, { useEffect, useState } from 'react';
import { Alert, Button, Stack } from '@mui/material';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../authConfig';


/**
 * Renders a drop down button with child buttons for logging in
 */

export const SignInButton = ({setUserInfo}) => {
  const [authError, setAuthError] = useState('');
  const { accounts, instance } = useMsal();

  const buildUserInfo = (account) => {
    const claims = account?.idTokenClaims || {};
    const roles = claims.roles || claims.groups || [];

    return {
      identityProvider: 'aad',
      userId: account.localAccountId || account.homeAccountId,
      userDetails: account.username || account.name,
      userRoles: roles.map((role) => String(role).toLowerCase()),
      claims,
      account,
    };
  };

  const handleLogin = async () => {
    setAuthError('');
    try {
      await instance.loginRedirect(loginRequest);
    } catch (error) {
      console.error('Microsoft Entra sign-in failed:', error);
      setAuthError('Microsoft Entra sign-in failed. Please try again.');
    }
  };

  useEffect(() => {
    if (accounts.length > 0) {
      setUserInfo(buildUserInfo(accounts[0]));
      setAuthError('');
    }
  }, [accounts, setUserInfo]);

  return (
    <>
      <Stack spacing={2}>
        {authError ? <Alert severity="error">{authError}</Alert> : null}
        <Button variant="outlined" onClick={handleLogin}> Sign in to SM4 </Button>
      </Stack>
    </>);
};
